import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';
import {
  fadeAnimation,
  scaleY,
} from 'src/app/shared/animations/fade.animation';
import { TemplateServicesService } from 'src/app/core/api-services/template-services/template-services.service';
import {
  ParticipantTemplate,
  ParticipantTemplateDto,
  TemplateServicesListResponse,
} from 'src/app/core/api-services/export/shared/template-services/TemplateServicesResponse';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { Router } from '@angular/router';
import { DsTableEmitHolder } from 'src/app/shared/ds-table/EsListEmitHolder';
import { DsTableOptions } from 'src/app/shared/ds-table/DsTableOptions';

@Component({
  selector: 'app-template-services',
  templateUrl: './template-services.component.html',
  animations: [fadeAnimation, scaleY],
})
export class TemplateServicesComponent extends BaseComponent implements OnInit {
  public isCollapsed: boolean[] = [];

  templates: ParticipantTemplate[] = [];

  searchText = '';

  options: DsTableOptions = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: false,
    allowReset: false,
    showOptions: true,
    customOptions: [
      {
        key: 'trEdit',
        styleClass: 'ds-btn-icon',
        behavior: {
          router: {
            link: {
              resolver: (row: { item: ParticipantTemplate; index: number }) => {
                return '/' + row.item.url.replace('?requestId=', '');
              },
            },
            queryParams: {
              resolver: (row: { item: ParticipantTemplate; index: number }) => {
                return {
                  procedureId: row.item.procedureId,
                  templateId: row.item.id,
                };
              },
            },
          },
        },
        icon: {
          styleClass: 'fi-register fi-large',
        },
      },
      {
        key: 'trCloneRequest',
        styleClass: 'ds-btn-icon',
        behavior: {
          router: {
            link: {
              resolver: (row: { item: ParticipantTemplate; index: number }) => {
                return '/' + row.item.url.replace('?requestId=', '');
              },
            },
            queryParams: {
              resolver: (row: { item: ParticipantTemplate; index: number }) => {
                return {
                  procedureId: row.item.procedureId,
                  cloneTemplateId: row.item.id,
                };
              },
            },
          },
        },
        icon: {
          styleClass: 'fa fa-clone',
        },
      },
    ],
  };

  public get ParticipantTemplate() {
    return ParticipantTemplate;
  }

  constructor(
    protected router: Router,
    private templateServicesService: TemplateServicesService,
    translateService: TranslateService
  ) {
    super(translateService);
  }

  async ngOnInit(): Promise<void> {
    const response = await this.templateServicesService.list().toPromise();

    this.templates = this.map(response);
  }

  private map(response: TemplateServicesListResponse): ParticipantTemplate[] {
    if (response && response.Data) {
      return response.Data.map((t) => this.mapTemplate(t));
    }

    return [];
  }

  public mapTemplate(t: ParticipantTemplateDto): ParticipantTemplate {
    return {
      id: t.ID,
      name: t.TemplateName,
      participantId: t.ParticipantID,
      procedureId: t.ProcedureID,
      service: {
        id: 0,
        nameAr: t.ServiceNameAr,
        nameEn: t.ServiceName,
      },
      template: t.Template,
      templateDetails: t.TemplateDetails,
      url: t.ServiceURL,
    };
  }

  public confirmDelete(item: ParticipantTemplate) {
    const sweet = this.showConfirmationSweet(item);

    sweet.then(async (result: any) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      } else if (result.value) {
        const result = await this.templateServicesService
          .delete(item.id)
          .toPromise();

        if (result.IsSuccess) {
          this.templates = this.templates.filter((t) => t.id != item.id);
        }
      }
    });
  }

  public confirmDeleteNew($event: DsTableEmitHolder<ParticipantTemplate>) {
    const sweet = this.showConfirmationSweet($event.item);

    sweet.then(async (result: any) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      } else if (result.value) {
        const result = await this.templateServicesService
          .delete($event.item.id)
          .toPromise();

        if (result.IsSuccess) {
          this.templates = this.templates.filter((t) => t.id != $event.item.id);
        }
      }
    });
  }

  public showConfirmationSweet(
    item: ParticipantTemplate
  ): Promise<SweetAlertResult<any>> {
    return Swal.fire({
      title: this.translateService.instant(
        'trDeleteTemplateConfirmationMessage',
        { templateName: item.name }
      ),
      icon: this.translateService.instant('ConfirmBoxWarning'),
      showCancelButton: true,
      confirmButtonText: this.translateService.instant('ConfirmBoxYesDeleteIt'),
      cancelButtonText: this.translateService.instant('ConfirmBoxNoKeepIt'),
    });
  }
}

export class TemplateServiceListEmitHolder {
  item: ParticipantTemplate;
}
